import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = (state, fileTyp) => {
    return selectOwnState(state).fetching[fileTyp]
}

export const selectVisualizationRequested = state => {
    return selectOwnState(state).visualizationRequested
}



// WEBPACK FOOTER //
// ./src/modules/customer/state/file-upload/selector.js